var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:{strike: _vm.showAlternative}},[_vm._v(" "+_vm._s(_vm.format(_vm.x))+" ")]),(_vm.showAlternative)?_c('span',[_vm._v(" "+_vm._s(_vm.format(_vm.y))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }